<template>
  <footer id="poweredBy">
    <span class="font-light d-inline-block mt-1">
      Copyright &copy; {{year}}</script> Sageflo, Inc.
    </span>
    <span>All Rights Reserved</span>
  </footer>
</template>
<script>
export default {
  data: function(){return {
    year: new Date().getFullYear(),
  }},
}
</script>